import { getCurrentInstance } from "vue";
import { BvToast } from "bootstrap-vue";

export const useToast = () => {
  const instance = getCurrentInstance();
  if (!instance) return {} as BvToast;
  return instance.proxy!.$root!.$bvToast;
};
